// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function toString(s) {
  switch (s) {
    case /* Deactivated */0 :
        return "deactivated";
    case /* Pending */1 :
        return "pending";
    case /* Scheduled */2 :
        return "scheduled";
    case /* Active */3 :
        return "active";
    
  }
}

function getStatus(status, start_date) {
  switch (status) {
    case /* Pending */0 :
        return /* Pending */1;
    case /* Scheduled */1 :
        if (Timestamp$Catalyst.isBefore(start_date, Timestamp$Catalyst.now(undefined))) {
          return /* Active */3;
        } else {
          return /* Scheduled */2;
        }
    case /* Rejected */2 :
    case /* Deleted */3 :
        return Curry._1(ErrorUtils$Catalyst.raiseError("ModificationStatusVm.re", "Invalid modification status", undefined), undefined);
    case /* Deactivated */4 :
        return /* Deactivated */0;
    
  }
}

export {
  toString ,
  getStatus ,
  
}
/* Timestamp-Catalyst Not a pure module */
